import {isSnakeCase, snakeToTitleCase} from './JsonTable';
import { Box, Typography, Card, CardContent } from '@mui/material';

function keyToEmoji(key) {
    const emojiMap = {
        // WorkItemUpdateLLM
        brief_summary: "📝", // For a concise project summary
        on_time_delivery: "⏱️", // On-time delivery assessment
        likelihood: "📊", // Likelihood of success
        justification: "🧾", // Justification for the likelihood
        highlights: "✨", // Highlights of the project
        features: "🚀", // Features delivered
        bugs: "🛠️", // Bug fixes
        other: "🔍", // Other achievements
        blockers: "🚧", // Current blockers
        dependencies: "🔗", // Dependencies across teams
        leadership_support: "📢", // Leadership support requests
        learnings: "📘", // Learnings gained
        customer: "🤝", // Customer insights
        market: "🌍", // Market insights
        technical: "💻", // Technical insights
        agent_actions: "🤖", // Actions taken by AI agents

        // TeamUpdateLLM
        summary: "📰", // Team health summary
        achievements: "🏆", // Team accomplishments
        challenges: "🌀", // Challenges faced
        insights: "💡", // Insights gained
        next_steps: "⏭️", // Next steps or priorities
        agent_actions: "🤖" // Actions taken by AI agents
    };

    return emojiMap[key] || ""; // Default to empty string if key is unknown
}



export function RecursiveJsonDisplay({ data, title, setAgentActionsContent }) {

    const renderJSON = (value, textPrefix="") => {
        if (Array.isArray(value)) {
            // return null if all items return null when rendered
            if (value.every((item) => renderJSON(item) == null)) {
                return null;
            }

            return (
                value.length == 0 ?
                    null :
                    <ul>
                        {value.map((item, index) => (
                            <li key={index}>{renderJSON(item, textPrefix="• ")}</li>
                        ))}
                    </ul>
            );
        } else if (typeof value === 'object' && value !== null) {
            // return null if all values return null when rendered
            if (Object.values(value).every((val) => renderJSON(val) == null)) {
                return null;
            }
            return (
                <div style={{ marginLeft: '20px', borderLeft: '1px solid #ccc', paddingLeft: '10px' }}>
                    {Object.entries(value).map(([key, val]) => (
                        renderJSON(val) == null || key == 'agent_actions' ? null :
                            <div key={key} style={{ marginBottom: '15px' }}>
                                <Typography variant="subtitle1">{keyToEmoji(key)} <strong>{isSnakeCase(key) ? snakeToTitleCase(key) : key}:</strong></Typography>
                                <div style={{ marginLeft: '10px' }}>{renderJSON(val)}</div>
                            </div>
                    ))}
                </div>
            );
        } else {
            // For primitive values (string, number, boolean, null)
            return (
                String(value) == '' ? null :
                    <Typography variant="subtitle2">{textPrefix + String(value)}</Typography>
            );
        }
    };

    if (data.agent_actions && data.agent_actions.length > 0) {
        setAgentActionsContent(data.agent_actions);   
    } else {
        setAgentActionsContent(null);
    }

    return (
        <Card variant="outlined">
            <CardContent>
                <Typography variant="h6" gutterBottom>{title}</Typography>
                {renderJSON(data)}
            </CardContent>
        </Card>
    );
};